import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Label variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const labelVariants = cva(['font-medium'], {
  variants: {
    variant: {
      default: ['text-body'],
      primary: ['text-primary-700'],
      secondary: ['text-secondary-700'],
      tertiary: ['text-tertiary-700'],
      heading: ['text-heading'],
      subtext: ['text-subtext'],
    },
    size: {
      l2: 'text-l2',
      l1: 'text-l1',
    },
    disabled: {
      true: 'opacity-50 cursor-not-allowed',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'l1',
    disabled: false,
  },
});

export type LabelVariantProps = VariantProps<typeof labelVariants>;
